export default __webpack_public_path__ + "static/media/nat_l.fa6f5231.jpg";